import { render, staticRenderFns } from "./CotizadorVida.vue?vue&type=template&id=8d97dd40&"
import script from "./CotizadorVida.vue?vue&type=script&lang=js&"
export * from "./CotizadorVida.vue?vue&type=script&lang=js&"
import style0 from "./CotizadorVida.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports